import { useUserSelector } from '@occc-app/App/AppContext';
import { User_Role } from '@occc/graphql';

import { useRetailerNetworkUserSelector } from '../../retailer-network-context/use-retailer-network-user.selector';

export const useGetIsUserPermittedToRemoveUserFromNetwork = () => {
  const currentUser = useUserSelector();
  const { isRetailerNetworkAdmin } = useRetailerNetworkUserSelector();
  const isCurrentUserAdmin = currentUser?.userRole === User_Role.Admin;

  if (isCurrentUserAdmin || isRetailerNetworkAdmin) {
    return true;
  }

  return false;
};
